export class ListActionApprovalRulesRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "filters",
            "baseName": "filters",
            "type": "ListActionApprovalRulesRequestFilters",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListActionApprovalRulesRequest.attributeTypeMap;
    }
    constructor() {
    }
}
